import styled from "styled-components/macro";

export const HotDogDotsContainer = styled.div`
  svg {
    circle {
      fill: var(--grey-1);
    }
  }
`;
